import React from 'react';
import cards from '../../cardList';
import './Card.scss';
import { Trans } from '@lingui/macro';

export default function Card(props) {
    const card = cards[props.type];
    const costDiscount = props.costDiscount ?? 0;
    const canAfford = props.canAfford ?? 1;
    const onClickEvent = canAfford ? props.onClick : null;

    if (!card) {
        console.error(`No card by type ${props.type}`);
        return null; // We can't render a non-existing card
    }

    let desc = card.description;
    let descParts = desc.split(/\[(Star|Damage|Energy|Heart|Roll-\w+|One-time-icon|Keep-icon|nl)\]/);
    for (let i = 1; i < descParts.length; i += 2) {
        if (descParts[i] === "nl") {
            descParts[i] = <br key={i} />;
        } else {
            const className = "game-sprite tiny-icon " + descParts[i].toLowerCase();
            descParts[i] = <span className={className} key={i}></span>;
        }
    }

    const typeClass = card.use_mode === "SINGLE" ? "one-time-use-card" : "keep-card";
    const typeName = card.use_mode === "SINGLE" ? <Trans>Use once</Trans> : <Trans>Passive</Trans>;
    const animationClass = props.animating ? 'animation-' + props.movementType : '';
    const costDiscountedClass = costDiscount ? 'card-energy-cost-discounted' : '';
    const costTooExpensiveClass = canAfford ? '' : 'energy-cost-expensive';
    return <div className={`card game-sprite ${typeClass} ${animationClass}`} onClick={onClickEvent} style={props.marginRight ? { marginRight: props.marginRight } : null}>
        <div className="card-energy-cost-container">
            <div className={`card-energy-cost ${costDiscountedClass} ${costTooExpensiveClass}`}>{card.cost - costDiscount}</div>
            <div className="card-energy-cost-icon"></div>
        </div>
        <div className="card-content">
            <p className="card-name">{card.name}</p>
            <p className="card-description">
                {descParts}
            </p>
        </div>
        <div className="card-type">
            <div className={`card-type-symbol game-sprite ${typeClass}-symbol`}></div>
            <div className="card-type-text">{typeName}</div>
        </div>
        <div className="card-appendix-hovering" style={props.appendixWidth ? { width: props.appendixWidth } : null}></div>
    </div >;
}
